import { ShapeEditorActorContext } from 'app/agriculture/forms/components/ShapeEditor/ShapeEditorMachine';
import { useContext, useEffect } from 'react';
import { ServicesContext } from 'app/items/shared/context_interface';

export function useKeyboardInputs() {
    const actor = ShapeEditorActorContext.useActorRef();
    const {
        mapService: { viewer },
    } = useContext(ServicesContext);

    useEffect(() => {
        const keyHandler = (event: KeyboardEvent) => {
            if (event.key === 'Delete' || event.key === 'Backspace') {
                actor.send({ type: 'editDeleteSelectedPoint' });
            }
        };
        window.addEventListener('keydown', keyHandler);

        return () => {
            window.removeEventListener('keydown', keyHandler);
        };
    }, [actor, viewer]);
}
